document.addEventListener('alpine:init', () => {
	Alpine.directive('scroll-into-view', (el, { modifiers }) => {
		setTimeout(() => {
			el.scrollIntoView({
				behavior: modifiers.includes('smooth') ? 'smooth' : 'auto',
				block: modifiers.includes('center') ? 'center' : 'nearest',
				inline: 'center',
			});
		});
	});

	Alpine.data('menuItem', () => ({}));

	Alpine.data('menu', () => ({
		hasTouchSupport: false,
		lastTouchTime: 0,
		init: function () {
			this.hasTouchSupport =
				window?.ontouchstart || navigator.maxTouchPoints > 0;
			// test
			// this.hasTouchSupport = true;
		},
		subMenu: {
			['x-show']() {
				return this.activeMenuItem ? true : false;
			},
		},
		primaryMenuItem: {
			['@click']() {
				/*
            if (!this.hasTouchSupport) {
                return;
            }
            e.preventDefault();
            */
			},
			/*
        ['@touchstart'](e) {
            if (!this.hasTouchSupport) {
                return;
            }

            const currentTime = new Date().getTime();
            const tapLength = currentTime - this.lastTouchTime;

            console.log(tapLength);
            if (tapLength < 500 && tapLength > 0) {
                const a = this.$el.querySelector('a');
                console.log(a);
                if (a && a?.href) {
                    window.location = a.href;
                }
            } else {
                this.hovered = true;

                const id = Array.from(this.$el.classList).find((c) =>
                    /^menu-item-\d+$/.test(c)
                );
                if (id) {
                    this.$store.menu.activeMenuItemId = id.replace(
                        'menu-item-',
                        ''
                    );
                }
            }
            this.lastTouchTime = currentTime;
        },
        */
			['@mouseenter']() {
				if (this.hasTouchSupport) {
					return;
				}
				this.hovered = true;
				const id = Array.from(this.$el.classList).find((c) =>
					/^menu-item-\d+$/.test(c)
				);
				if (id) {
					this.$store.menu.activeMenuItemId = id.replace(
						'menu-item-',
						''
					);
				}
			},
			['@mouseleave']() {
				if (this.hasTouchSupport) {
					return;
				}
				this.hovered = false;
				this.$store.menu.activeMenuItemId = null;
			},
			[':style']() {
				return {
					color: this.$el.classList.contains(
						`menu-item-${this.$store.menu.activeMenuItemId}`
					)
						? 'var(--menu-color)'
						: '',
				};
			},
		},
		clonedMenuItem: {
			['@mouseenter']() {
				const id = Array.from(this.$el.classList).find((c) =>
					/^menu-item-\d+$/.test(c)
				);
				if (id) {
					this.$store.menu.activeMenuItemId = id.replace(
						'menu-item-',
						''
					);
				}
			},
			['@mouseleave']() {
				this.$store.menu.activeMenuItemId = null;
			},
			[':style']() {
				// console.log('ffff', this.$store.menu.activeMenuItemId);
				const hasActiveMenuItemId = this.$store.menu.activeMenuItemId;

				const containsActiveMenuItemId = this.$el.classList.contains(
					`menu-item-${this.$store.menu.activeMenuItemId}`
				);

				/*
            console.log(
                this.$store.menu.activeMenuItemId,
                hasActiveMenuItemId,
                containsActiveMenuItemId
            );
            */

				if (containsActiveMenuItemId) {
					console.log('menu: contains active menu item id');
					return { display: 'block' };
				}

				if (
					!hasActiveMenuItemId &&
					this.$el.classList.contains('current-menu-item')
				) {
					console.log('menu: current-menu-item');
					return { display: 'block' };
				}

				if (
					!hasActiveMenuItemId &&
					this.$el.classList.contains('current-menu-parent')
				) {
					console.log('menu: current-menu-parent');
					return { display: 'block' };
				}

				if (
					!hasActiveMenuItemId &&
					this.$el.querySelector('.current-query-var-category')
				) {
					return { display: 'block' };
				}

				/*
				if (
					!hasActiveMenuItemId &&
					this.$el.classList.contains('current-post-ancestor')
				) {
					return { display: 'block' };
				}
				*/

				if (
					!hasActiveMenuItemId &&
					this.$el.classList.contains('current-post-parent')
				) {
					console.log('menu: current-post-parent');
					return { display: 'block' };
				}

				return { display: 'none' };
			},
		},
		clonedSubMenuItem: {},
		delay: function (ms) {
			return new Promise((res) => setTimeout(res, ms));
		},
		toggleSubMenu: function (e, menuItemEl) {
			this.menuItemEls.forEach((element) => {
				element.classList.remove('text-(--menu-color)');
			});
			const elements =
				this.$refs.subMenuEl.querySelectorAll('.menu-item-depth-0');

			elements.forEach((element) => {
				element.style.display = 'none';
			});

			const id = e.target.parentNode.id.replace('menu-item-', '');

			const element = this.$refs.subMenuEl.querySelector(
				`.menu-item-depth-0.menu-item-${id}`
			);
			if (!element) {
				return;
			}

			menuItemEl.classList.add('text-(--menu-color)');
			element.style.display = 'flex';
		},
		initMenu: function () {
			if (/Mobi|Android/i.test(navigator.userAgent)) {
				this.menuItemEls = document.querySelectorAll(
					'#primary-menu .menu-item-depth-0 > a'
				);
				this.menuItemEls.forEach((menuItemEl) => {
					menuItemEl.addEventListener('click', (e) => {
						e.preventDefault();
						this.toggleSubMenu(e, menuItemEl);
					});
					menuItemEl.addEventListener('dblclick', (e) => {
						e.preventDefault();
						// Was `e.target.getAttribute('href');` on its own line, throwing
						// the result away, followed by `if (url)` reading an identifier
						// that was never declared — a guaranteed ReferenceError had this
						// ever run. It never did: initMenu is called from nowhere.
						// See docs/js-build-review.md J4.
						const url = e.target.getAttribute('href');
						if (url) {
							window.location.href = url;
						}
					});
				});
			} else {
				console.log('gggg');
				const menu = document.querySelector('#primary-menu');

				menu.addEventListener('mousemove', async () => {
					console.log(1234);
					const hovered = menu.querySelector(
						'.menu-item-depth-0:hover'
					);
					console.log('hovered', hovered);
					if (hovered) {
						const items =
							this.$refs.subMenuEl.querySelectorAll(
								'.menu-item-depth-0'
							);
						items.forEach((item) => {
							item.style.display = 'none';
						});

						const id = hovered.id.replace('menu-item-', '');

						const element = this.$refs.subMenuEl.querySelector(
							`.menu-item-depth-0.menu-item-${id}`
						);
						element.style.display = 'flex';
					} else {
						// await delay(1000);
						const items = document.querySelectorAll(
							'#sub-menu-cloned .menu-item-depth-0'
						);

						items.forEach((item) => {
							item.style.removeProperty('display');
						});
					}
				});

				menu.addEventListener('mouseleave', () => {
					const items = document.querySelectorAll(
						'#sub-menu-cloned .menu-item-depth-0'
					);

					items.forEach((item) => {
						item.style.removeProperty('display');
					});
				});
			}
		},
		cloneSubMenu: function (e) {
			const subMenu = e.target.querySelector('.sub-menu');
			const container = this.$refs.clonedMenuContainerEl;

			console.log('ggg', subMenu, container);

			if (!subMenu || !container) return;

			const clonedSubMenu = subMenu.cloneNode(true);
			container.appendChild(clonedSubMenu);
			console.log(this, e);
		},
	}));

	Alpine.data('hamburger', () => ({
		top: '',
		init: function () {
			this.$watch('$store.hamburger.open', (value) => {
				if (value) {
					this.setTop();
				}
			});
			// Build clones & wire up click-to-expand once on init
			this.setupMenu();
		},
		setupMenu: function () {
			const parentItems = this.$el.querySelectorAll(
				'li.menu-item-has-children'
			);

			parentItems.forEach((parentItem) => {
				const subMenuEl =
					parentItem.querySelector(':scope > .sub-menu');
				if (!subMenuEl) return;

				// 1) Clone the parent link and insert it as the first item of the sub-menu
				const parentAnchor = parentItem.querySelector(':scope > a');
				if (
					parentAnchor &&
					!subMenuEl.querySelector('.sub-menu-parent-clone')
				) {
					const cloneLi = document.createElement('li');
					cloneLi.className =
						'sub-menu-parent-clone pl-4 bg-white relative font-semibold text-base w-full hover:bg-[#f8f8f8] text-black hover:text-(--menu-color) [&>a]:block [&>a]:p-4';
					const cloneAnchor = parentAnchor.cloneNode(true);
					cloneLi.appendChild(cloneAnchor);
					subMenuEl.insertBefore(cloneLi, subMenuEl.firstChild);
				}

				// 2) Intercept the parent anchor click to expand/collapse the sub-menu
				if (parentAnchor) {
					parentAnchor.addEventListener('click', (e) => {
						e.preventDefault();

						// Collapse sibling sub-menus at the same level
						const parentList = parentItem.parentElement;
						parentList
							.querySelectorAll(
								':scope > li.menu-item-has-children > .sub-menu'
							)
							.forEach((sm) => {
								if (sm !== subMenuEl) {
									sm.classList.add('hidden');
									sm.closest('li').classList.remove(
										'is-open'
									);
								}
							});

						subMenuEl.classList.toggle('hidden');
						parentItem.classList.toggle(
							'is-open',
							!subMenuEl.classList.contains('hidden')
						);
					});
				}
			});
		},
		setTop: function () {
			const header = document.querySelector('header');
			if (header) {
				const headerHeight = header.offsetHeight;
				const adminBarHeight =
					parseInt(
						getComputedStyle(
							document.documentElement
						)?.marginTop?.replace('px', '')
					) || 0;

				this.top =
					Math.max(
						0,
						adminBarHeight + headerHeight - window.scrollY
					) + 'px';
			}
		},
	}));
});
